import Player from "./objects/dino-player";
import Cactus from "./objects/dino-cactus";
import Cloud from "./objects/dino-cloud";
import Blank from "./objects/dino-blank";
import Ground from "./objects/dino-ground";

import { showScore, resetScore } from "./ui/score";
import { hidePressToPlay, hideGameOver } from "./ui/gameState";

import generateAnimations from "./animations/dino-index";

class Dino extends Phaser.Scene {
  constructor() {
    super("Dino");

    this.state = {
      score: 0,
      highScore: 0,
      levelUpScore: 0,
      speed: 1,
      started: false,
      UIUpdated: false,
      gameOver: false,
      cactuses: [],
      grounds: [],
      numberOfStars: 3,
      stars: [],
      numberOfClouds: 4,
      clouds: [],
      cactusDistance: 2000,
      timer: {
        speedLoop: 0,
        cactusSpawnLoop: 0,
      },
      xVelocity: -500,
      sounds: {
        jump : null,
        gameOver: null,
        levelUp: null
      }
    };
  }

  preload() {
    this.load.audio('jump', ['./assets/dino-jump.mp3']);
    this.load.audio('gameOver', ['./assets/dino-gameover.mp3']);
    this.load.audio('levelUp', ['./assets/dino-levelup.mp3']);

    this.load.spritesheet("cactus", "./assets/dino-cactus.png", {
      frameWidth: 16,
      frameHeight: 26,
    });
    this.load.spritesheet("blank", "./assets/dino-blank.png", {
      frameWidth: 1280,
      frameHeight: 10,
    });
    this.load.spritesheet("ground", "./assets/dino-ground.png", {
      frameWidth: 192,
      frameHeight: 120,
    });
    this.load.spritesheet("cloud", "./assets/dino-cloud.png", {
      frameWidth: 96,
      frameHeight: 48,
    });
    this.load.atlas("atlas", "./assets/dino-rex.png", "./assets/dino-rex.json");

    this.load.on("complete", () => {
      generateAnimations(this);
    });
  }

  create() { 
    let playAgain = document.getElementById('play-again');
    playAgain.addEventListener('click', (e) => this.restartGame(e));
    this.state.sounds.jump = this.sound.add('jump');
    this.state.sounds.gameOver = this.sound.add('gameOver');
    this.state.sounds.levelUp = this.sound.add('levelUp');
    this.player = new Player(this, 70, 200);
    this.blank = new Blank(this)
    
    for (let index = 0; index < 8; index++) {
      this.state.grounds.push(new Ground(this, index * 384));
    }

    for (let index = 0; index < this.state.numberOfClouds; index++) {
      this.state.clouds.push(new Cloud(this));
    }

    this.inputs = this.input.keyboard.createCursorKeys();
  }

  update(time, delta) {
      

    if (this.state.score - this.state.levelUpScore > 100) {
      this.state.sounds.levelUp.play()
      this.state.levelUpScore += 100
    }
    
    this.state.clouds.forEach((cloud) => {
      cloud.update();
      if (cloud.sprite.x < -200) {
        let randomXPosition = Math.floor(Math.random() * 1400) + 1400;
        let randomYPosition = Math.floor(Math.random() * 200) + 48;
        cloud.sprite.x = randomXPosition;
        cloud.sprite.y = randomYPosition;
      }
    });

    this.pointer = this.input.activePointer;


    if (this.state.started) {
      let groundsIndex = this.state.grounds.length;
      while (groundsIndex--) {
        this.state.grounds[groundsIndex].update(this.state.xVelocity);
        if (this.state.grounds[groundsIndex].sprite.x < -300) {
          this.state.grounds.splice(groundsIndex, 1);
        }
      }

      let cactusesIndex = this.state.cactuses.length;
      while (cactusesIndex--) {
        this.state.cactuses[cactusesIndex].update(this.state.xVelocity);
        if (this.state.cactuses[cactusesIndex].sprite.x < -300) {
          this.state.cactuses.splice(cactusesIndex, 1);
        }
      }

    }

    if (this.state.grounds[this.state.grounds.length - 1].sprite.x < 1300) {
      this.state.grounds.push(
        new Ground(
          this,
          this.state.grounds[this.state.grounds.length - 1].sprite.x + 360
        )
      );
    }

    this.state.timer.speedLoop += delta;
    this.state.timer.cactusSpawnLoop += delta;

    if (
      this.inputs.space.isDown &&
      !this.state.started &&
      !this.state.gameOver
    ) {
      this.state.started = true;
    }

    if (this.pointer.isDown && !this.state.started && !this.state.gameOver) {
      this.state.started = true;
    }

    if (this.state.started) {
      this.player.update(this.inputs, delta);

      if (!this.state.UIUpdated) {
        this.updateUI();
      }

      if (this.state.timer.cactusSpawnLoop > this.state.cactusDistance) {
        let randomSpeed = (Math.floor(Math.random() * 1.5) + .4) * this.state.speed
        this.state.cactusDistance = Phaser.Math.Between( 
          1300 / randomSpeed,
          1300 / randomSpeed
        );


        let quantityOfCactuses = Math.floor(Math.random()*2)+1

        for (let i = 0; i < quantityOfCactuses; i++){
          this.state.cactuses.push(new Cactus(this,i));
        }

        if (quantityOfCactuses > 1){
          this.state.timer.cactusSpawnLoop = -100;
        }
        else {
          this.state.timer.cactusSpawnLoop = 0;
        }
        
      }

      if (this.state.timer.speedLoop > 400) {
        this.state.timer.speedLoop = 0;
        this.state.speed += 0.01  ;
        this.state.xVelocity *= 1.005;
      }
    }

    if (this.state.gameOver) {
      this.state.xVelocity = -500;
      this.state.cactuses.forEach((cactus) => cactus.stop());
      this.state.grounds.forEach((ground) => ground.stop());
    }


  }


  updateUI() {
    hidePressToPlay();
    hideGameOver();

    showScore();

    this.state.UIUpdated = true;
  }

  restartGame() {
    hideGameOver();
    resetScore(this.state);

    this.state.started = true;
    this.state.gameOver = false;
    this.state.speed = 1;
    this.state.cactuses.forEach((cactus) => cactus.sprite.destroy());

    this.state.cactuses = [];

    this.player.isDead = false;
  }
}

export default Dino;
